'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of user
 */ const User = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 105 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.0508",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M37.5312 33.5154C37.5312 41.1996 43.8259 47.4254 51.5831 47.4254C59.3403 47.4254 65.635 41.1996 65.635 33.5154C65.635 25.8313 59.3457 19.6055 51.5831 19.6055C43.8206 19.6055 37.5312 25.8313 37.5312 33.5154Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M63.6275 51.1211C60.188 53.4501 56.0414 54.8144 51.5787 54.8144C47.116 54.8144 42.9641 53.4501 39.5246 51.1211C32.7422 54.905 28.1562 62.1158 28.1562 70.4032V73.2917C28.1562 76.4148 30.701 78.941 33.8351 78.941H69.317C72.4511 78.941 74.9959 76.4095 74.9959 73.2917V70.4032C74.9959 62.1158 70.4099 54.905 63.6275 51.1211Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M65.754 62.2023L62.3164 65.3754C61.978 65.6878 61.9575 66.2157 62.2708 66.5534L69.6422 74.4985C69.9577 74.8387 70.4905 74.8552 70.8265 74.5353L83.4182 62.5477C83.7545 62.2275 83.7639 61.6941 83.4391 61.3623L79.8558 57.702C79.5403 57.3797 79.0256 57.3672 78.6949 57.6738L70.8036 64.9888C70.4754 65.293 69.9654 65.2834 69.6489 64.9669L66.9074 62.2253C66.5914 61.9094 66.0823 61.8992 65.754 62.2023Z",
                fill: theme.ds5.asset[assetColor]["100"]
            })
        ]
    });
};

exports.User = User;
//# sourceMappingURL=User.cjs.map
